import React from 'react';
import Typography from '@mui/material/Typography';

export const WatchlistColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Name of Entity</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Program</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Source Country</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>List Name</Typography>
      </div>
    </>
  );
};

export default WatchlistColumns;
